module.exports = __webpack_public_path__ + "static/mobile-pana-64fc634879c202f11bb73240c26aa719.svg";